// Input de nota com máscara: cursor à direita, dígitos fluem para a esquerda, máx 2 decimais
import React, { useRef, useEffect } from 'react';

export const GradeInput = ({ value, onChange, style = {}, placeholder = '0,00', max = 100 }) => {
  const inputRef = useRef(null);
  const cents = Math.round((Number(value) || 0) * 100);
  const display = value !== undefined && value !== null && value !== '' 
    ? Number(value).toFixed(2).replace('.', ',') 
    : '';

  useEffect(() => {
    if (inputRef.current && document.activeElement === inputRef.current) {
      inputRef.current.setSelectionRange(display.length, display.length);
    }
  }, [display]);

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const newCents = Math.floor(cents / 10);
      onChange(Math.round(newCents) / 100);
      return;
    }
    if (e.key >= '0' && e.key <= '9') {
      e.preventDefault();
      const digit = parseInt(e.key, 10);
      const newCents = Math.min(cents * 10 + digit, Math.round(max * 100));
      onChange(Math.round(newCents) / 100);
      return;
    }
    if (e.key === ',' || e.key === '.') {
      e.preventDefault();
      return;
    }
  };

  const handleFocus = (e) => {
    e.target.setSelectionRange(display.length, display.length);
  };

  return (
    <input
      ref={inputRef}
      type="text"
      inputMode="numeric"
      readOnly
      value={display}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      style={{ ...style, cursor: 'text' }}
      placeholder={placeholder}
      title="Digite os números (0-9). Backspace apaga. Máx 2 casas decimais."
      data-grade-input
    />
  );
};
